import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { getTiktokCallbackPath } from "./callback-path";

export const tiktokRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Tiktok" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        loader() {
          const path = getTiktokCallbackPath(new URL(location.href));
          if (!path) {
            return null;
          }
          // A full navigation makes AuthProvider load the store's own login,
          // and holding the loader keeps the login gate from rendering first.
          location.replace(path);
          return new Promise<never>(() => {});
        },
        async lazy() {
          const { TiktokCallback } = await import("./callback");
          return { Component: TiktokCallback };
        },
      },
    ],
  },
];
